var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"width":_vm.width,"src":require("@/assets/img/loading-lg.svg"),"alt":"Carregando rapá"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }